import { PlayedPosition } from '@statsbomb/parachute-types';
import { atom } from 'jotai';
import { atomWithSuspenseQuery } from 'jotai-tanstack-query';
import { atomWithDebounce } from '@/atoms/debounce';
import { comparisonIdAtom } from '@/atoms/queryParams';
import { Nullable } from '@/types/generic';
import { NestedObject } from '@/types/object';
import { convertFilterParamsToString, hasEmptyInFilters } from '@/utils/api';
import { objSnakeToCamel } from '@/utils/queries';
import { fetchClientAtom } from '../client';

export const playerComparisonPositionsFilterDebounceObject = atomWithDebounce<Nullable<NestedObject>>(null);
const { debouncedValueAtom: playerComparisonPositionsFilterAtom } = playerComparisonPositionsFilterDebounceObject;

const rawPlayerComparisonPositionsAtom = atomWithSuspenseQuery(get => {
  const { fetch } = get(fetchClientAtom);
  const comparisonId = get(comparisonIdAtom);
  const filterParams = get(playerComparisonPositionsFilterAtom);
  const queryKey = ['playerComparisonPositions', comparisonId, filterParams] as const;

  const queryFn = async ({ queryKey: [, comparisonId, filterParams] }: { queryKey: typeof queryKey }) => {
    if (!comparisonId || hasEmptyInFilters(filterParams)) return [];
    return (await fetch(
      `/player/${comparisonId}/positions${convertFilterParamsToString(filterParams)}`,
    )) as PlayedPosition[];
  };

  return { queryKey, queryFn };
});

export const playerComparisonPositionsAtom = atom(async get => {
  const raw = await get(rawPlayerComparisonPositionsAtom);
  return raw.data.map(objSnakeToCamel);
});
